<script setup lang="ts">
import { useGalleryState } from '@/composables/useGalleryState'
import { useSocialShare } from '@/composables/useSocialShare'
import { computed } from 'vue'
import { useLanguage, useTranslateSource } from '@/composables/useLanguage'

const { language } = useLanguage()
const { ts } = useTranslateSource()
const { gallery, activeSlide, showThumbnails } = useGalleryState()
const { shareFb, shareXPlatform, shareWsApp } = useSocialShare()

const textSource = ts(language.value, 'source')

const description = computed(() => {
  return gallery.value.images[activeSlide.value] ? gallery.value.images[activeSlide.value].texts.description.trim() : ''
})

const author = computed(() => {
  return gallery.value.images[activeSlide.value] ? gallery.value.images[activeSlide.value].texts.author.trim() : ''
})

const socialShareEnabled = computed(() => {
  return gallery.value.config.socialShareEnabled ?? true
})
</script>

<template>
  <div class="gallery-info">
    <div v-show="!showThumbnails" class="data">
      <span v-if="description.length > 0" class="description">{{ description }}</span>
      <span v-if="author.length > 0" class="author">{{ textSource }}:&nbsp;{{ author }}</span>
    </div>
    <div v-if="socialShareEnabled" class="share-controls">
      <span class="btn-share btn-share-fb" @click.stop="shareFb">
        <svg aria-hidden="true" class="svg-icon" viewBox="0 0 19 32">
          <use xlink:href="#svg-icon-fb"></use>
        </svg>
      </span>

      <span class="btn-share btn-share-x-platform" @click.stop="shareXPlatform">
        <svg aria-hidden="true" class="svg-icon" viewBox="0 0 19 32">
          <use xlink:href="#svg-icon-x-platform"></use>
        </svg>
      </span>

      <span class="btn-share btn-share-wsapp" @click.stop="shareWsApp">
        <svg aria-hidden="true" class="svg-icon" viewBox="0 0 21 24">
          <use xlink:href="#svg-icon-wsapp"></use>
        </svg>
      </span>
    </div>
  </div>
</template>
